//@ flow
const changeBaselineCell = (payload) => {
    const {
        newValue,
        lineItemUrid,
        rowIndex,
        ucid
    } = payload;
    window.dispatchEvent(
        new CustomEvent('baselinePayloadUpdated', {
            detail: {
                payload: 'Baseline Payload updated successfully',
                stopLoading: true,
                type: 'success',
                newValue: newValue,
                lineItemUrid: lineItemUrid,
                rowIndex: rowIndex,
                ucid: ucid
            }
        })
    );
    return;
}

export default changeBaselineCell;
